import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_NLP_FLOWS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the NLP flows.'),
      403: i18n.t('You are not allowed to fetch the NLP flows.'),
      404: i18n.t('The NLP flows you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the NLP flows.'),
      default: i18n.t('An error occurred fetching the NLP flows.')
    }
  },

  FETCH_NLP_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the NLP flow.'),
      403: i18n.t('You are not allowed to fetch the NLP flow.'),
      404: i18n.t('The NLP flow you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the NLP flow.'),
      default: i18n.t('An error occurred fetching the NLP flow.')
    }
  },

  CREATE_NLP_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to create the NLP flow.'),
      403: i18n.t('You are not allowed to create the NLP flow.'),
      404: i18n.t('The NLP flow you are trying to create does not exist.'),
      500: i18n.t('There was an error creating the NLP flow.'),
      default: i18n.t('An error occurred creating the NLP flow.')
    },
    SUCCESS: {
      200: i18n.t('NLP flow created successfully.'),
      201: i18n.t('NLP flow created successfully.')
    }
  },

  UPDATE_NLP_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to update the NLP flow.'),
      403: i18n.t('You are not allowed to update the NLP flow.'),
      404: i18n.t('The NLP flow you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the NLP flow.'),
      default: i18n.t('An error occurred updating the NLP flow.')
    },
    SUCCESS: {
      200: i18n.t('NLP flow updated successfully.')
    }
  },

  DELETE_NLP_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the NLP flow.'),
      403: i18n.t('You are not allowed to delete the NLP flow.'),
      404: i18n.t('The NLP flow you are trying to delete does not exist.'),
      500: i18n.t('There was an error deleting the NLP flow.'),
      default: i18n.t('An error occurred deleting the NLP flow.')
    },
    SUCCESS: {
      200: i18n.t('NLP flow deleted successfully.')
    }
  }
};
